import { Injectable } from '@angular/core';

export interface LocalStorageConfig {
  prefix?: string;
  storageType?: 'localStorage' | 'sessionStorage';
}

const DEFAULT_PREFIX = 'brover';

@Injectable({ providedIn: 'root' })
export class LocalStorageService {
  private prefix = DEFAULT_PREFIX;
  private storage: Storage = typeof window !== 'undefined' ? window.localStorage : ({} as Storage);

  configure(config: LocalStorageConfig): void {
    if (config.prefix !== undefined) {
      this.prefix = config.prefix;
    }
    if (config.storageType === 'sessionStorage' && typeof window !== 'undefined') {
      this.storage = window.sessionStorage;
    }
  }

  private k(key: string): string {
    return this.prefix ? `${this.prefix}.${key}` : key;
  }

  set(key: string, value: any): boolean {
    try {
      this.storage.setItem(this.k(key), JSON.stringify(value));
      return true;
    } catch {
      return false;
    }
  }

  get<T>(key: string): T | null {
    const raw = this.storage.getItem(this.k(key));
    if (raw === null) {
      return null;
    }
    try {
      return JSON.parse(raw) as T;
    } catch {
      return raw as unknown as T;
    }
  }

  remove(...keys: string[]): boolean {
    keys.forEach(key => this.storage.removeItem(this.k(key)));
    return true;
  }

  keys(): string[] {
    const out: string[] = [];
    const prefix = this.prefix ? `${this.prefix}.` : '';
    for (let i = 0; i < this.storage.length; i++) {
      const k = this.storage.key(i);
      if (k && (!prefix || k.startsWith(prefix))) {
        out.push(prefix ? k.substring(prefix.length) : k);
      }
    }
    return out;
  }
}
